// import { useContext } from "react";
import { Formik, Form, Field } from "formik";
import FormWrapper from "components/FormWrapper";
import ResetAndSubmit from "components/ResetAndSubmit";
// import * as Yup from "yup";
// import { AppContext } from "state";
import ImageUpload2 from "components/ImageUpload/index2";
import { Img } from "components";
import ComingSoon from "pages/Onboarding/component/ComingSoon";

// const validationSchema = Yup.object().shape({
//     BANK_NAME: Yup.string().required("Bank name is Required"),
//     ACCOUNT_HOLDER_NAME: Yup.string().required("Account holder name is required"),
//     ACCOUNT_NAME: Yup.string().required("Account name is required"),
//     ACCOUNT_NUMBER: Yup.string().required("Account number is required"),
//     IFSC_CODE: Yup.string().required("IFSC Code is required"),
//     UPI_ID: Yup.string().required("UPI is required"),
//     REGISTRATION_CERTIFICATE: getImageValidationSchema("Registration Certificate is Required"),
// })

const ParentInsights = ({ handleNavigate, resetFormData, disableForm }: { handleNavigate, resetFormData?: any, titleAndDesNotRequired?: boolean, disableForm?: boolean }) => {
    // const { globalData } = useContext(AppContext);
    const emptyAIManagmentHubData = {
        CERTIFICATE_LIST: []
    };

    return <div className="flex justify-center">
        <ComingSoon />
    </div>
    {/* <Formik
        initialValues={{ ...(Boolean(JSON.parse(sessionStorage.getItem("parentalInsights"))) ? JSON.parse(sessionStorage.getItem("parentalInsights")) || {} : emptyAIManagmentHubData) }}
        enableReinitialize
        // validationSchema={validationSchema}
        onSubmit={(values) => {
            console.log("values ", values)
            sessionStorage.setItem("parentalInsights", JSON.stringify(values));
            handleNavigate();
        }}
    >
        {({ values, handleSubmit, resetForm, errors, setFieldValue }) => <FormWrapper
            title={"Import Your Institution's Student Data"}
            childern={<Form onSubmit={handleSubmit}>
                <div className="grid grid-cols-3 gap-4">
                    <div className="col-span-3">
                        <Field name={`CERTIFICATE_LIST`}>
                            {({ field, form }) => (
                                <ImageUpload2
                                    accept={{
                                        "text/csv": [".csv"],
                                        "application/vnd.ms-excel": [".xls"],
                                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
                                    }}
                                    isError={!!errors?.CERTIFICATE_LIST}
                                    disable={disableForm}
                                    label="Upload Student Data File"
                                    wantHDOption
                                    maxSize={5}
                                    labelClassNames="text-[2vh]"
                                    containerHeight={{
                                        width: "7vh",
                                        height: "7vh",
                                    }}
                                    multiImageValues={field.value}
                                    onMultiDelete={removeIndex => {
                                        form.setFieldValue(`CERTIFICATE_LIST`, values?.CERTIFICATE_LIST?.filter((_, index) => Number(index) !== Number(removeIndex)));
                                    }}
                                    onChange={(item) => {
                                        if (values?.CERTIFICATE_LIST?.length) {
                                            form.setFieldValue(`CERTIFICATE_LIST`, [item, ...values?.CERTIFICATE_LIST])
                                        } else {
                                            form.setFieldValue(`CERTIFICATE_LIST`, [item])
                                        }
                                    }}
                                />
                            )}
                        </Field>
                    </div>
                    <div className="col-span-3">
                        <p className="text-[black] font-medium text-sm">Download Our Sample File for Reference</p>
                    </div>
                    <div className="col-span-3 mb-5">
                        <button type="button" className="w-full flex justify-between items-center rounded-xl bg-gray-100 flex gap-2 p-2">
                            <p className="text-sm">Our Excel Sample</p>
                            <Img src={"/images/download.svg"} className="w-6 h-6" />
                        </button>
                    </div>
                   
                </div>
                {!disableForm && <ResetAndSubmit
                    // submitToolTip={Boolean(Object.keys(errors)?.length) ? "Please fill in all the required fields." : ""}
                    // isError={Boolean(Object.keys(errors)?.length)}
                    resetForm={() => {
                        resetForm();
                        resetFormData();
                    }}
                />}
            </Form>}
        />}
    </Formik> */}
};

export default ParentInsights;
